import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@NgModule({
    imports: [
        
    ],
    declarations: [
        
    ],
    exports: [
        
    ],
    providers: [],
})

export class ConnectModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/connect/connect.module.ts